import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Translate, { t } from '../common/Translate';

const CustomCost = (props) => {
  const recordId = useSelector((state) => state.reduxRecords?.currentRecord);
  const country = useSelector((state) => state.reduxRecords.data[recordId]?.record?.country);
  const { questionId, label, setLabel, cost, setCost } = props;
  const isUkFile = country === 'UK';

  const handleCost = (e) => {
    let { value } = e.target;
    if (value) value = parseInt(value, 10);
    if (value === 0) return setCost('');
    if (value < 0) value *= -1;
    return setCost(value);
  };

  return (
    <div className="p-3" data-cy={questionId}>
      <div className="form-group">
        <label className="pl-2 text-left">
          <Translate code="custom_damage" />
        </label>
        <input
          id="label"
          name="label"
          type="text"
          className="text-left form-control"
          defaultValue={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder={t(`ex_${questionId}`)}
          data-cy="label"
          value={label}
        />
      </div>
      <div className="form-group mt-4" data-cy={questionId}>
        <label className="pl-2 text-left">
          <Translate code="cost" />
        </label>
        <div className="pseudo-input-currency">
          <input
            id="cost"
            inputMode="tel"
            pattern="[0-9]*"
            name="cost"
            type="number"
            className="text-left form-control"
            value={cost}
            onChange={(e) => handleCost(e)}
            placeholder={t('costExample')}
            data-cy="cost"
          />
          <div className="currency-wrapper">{t(isUkFile ? '£_manuel_cost_TTC' : '€_manuel_cost_TTC')}</div>
        </div>
      </div>
    </div>
  );
};

CustomCost.propTypes = {
  questionId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setLabel: PropTypes.func.isRequired,
  cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setCost: PropTypes.func.isRequired,
};

export default CustomCost;
